import { RESULTS_ROOT, STORE_ROOT } from 'utils/constants/urls';

/**
 * Check if the given url is pointing to store prod, and translate it properly to
 * the current environment
 *
 * @examples
 *  QA env
 *  https://secure.everlywell.com/telehealth/sessions/new -> https://secure-qa.everlywell.com/telehealth/sessions/new
 *
 *  Staging env
 *  https://secure.everlywell.com/telehealth/sessions/new -> https://secure-staging.everlywell.com/telehealth/sessions/new
 *
 *  Relative url
 *  /virtual-care-visits -> /virtual-care-visits
 *
 * @param {string} url
 * @param {URLSearchParams} queryParams
 * @returns {string}
 */
export const replaceRedirectionLinkRoot = (
  url: string,
  queryParams?: URLSearchParams,
): string => {
  let modifiedUrl = url; // Create a copy of the original URL

  if (modifiedUrl.startsWith('https://secure.everlywell.com')) {
    modifiedUrl = modifiedUrl.replace(
      /^https:\/\/secure.everlywell\.com/,
      STORE_ROOT,
    );
  } else if (modifiedUrl.startsWith('https://results.everlywell.com/')) {
    modifiedUrl = modifiedUrl.replace(
      /^https:\/\/results.everlywell\.com/,
      RESULTS_ROOT,
    );
  }

  // Append query parameters if queryParams object is provided
  if (queryParams && queryParams.toString()) {
    modifiedUrl +=
      (modifiedUrl.includes('?') ? '&' : '?') + queryParams.toString();
  }

  return modifiedUrl;
};
